module.exports = __webpack_public_path__ + "static/img/14l.0d18fc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14l.jpg
// module id = NXXN
// module chunks = 0